var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { LabelByStudentsFilter, } from '../../../../constants/filters';
var FILTER_GROUPS_BY_ORDER = [
    "NeedIntervention" /* NeedIntervention */,
    "OnTrack" /* OnTrack */,
    "NotStarted" /* NotStarted */,
];
var sortByName = function (student1, student2) {
    if (student1.name < student2.name) {
        return -1;
    }
    if (student1.name > student2.name) {
        return 1;
    }
    return 0;
};
var sortByAccuracy = function (student1, student2) {
    var _a, _b;
    var result = ((_a = student1.accuracy) !== null && _a !== void 0 ? _a : 0) - ((_b = student2.accuracy) !== null && _b !== void 0 ? _b : 0);
    if (result)
        return result;
    return sortByName(student1, student2);
};
var sortOnTrackStudents = function (student1, student2) {
    if (student1.status !== student2.status) {
        if (student1.status === "in_progress" /* Active */)
            return -1;
        if (student2.status === "in_progress" /* Active */)
            return 1;
        if (student1.status === "completed" /* Completed */)
            return -1;
        if (student2.status === "completed" /* Completed */)
            return 1;
    }
    return sortByAccuracy(student1, student2);
};
var sortNotStartedStudents = function (student1, student2) {
    if (student1.status !== student2.status) {
        if (student1.status === "not_started" /* NotStarted */)
            return -1;
        if (student2.status === "not_started" /* NotStarted */)
            return 1;
        if (student1.status === "canceled_by_card" /* CanceledByCard */)
            return -1;
        if (student1.status === "canceled_by_teacher" /* CanceledByTeacher */)
            return -1;
        if (student1.status === "canceled_by_time" /* CanceledByTime */)
            return -1;
        if (student2.status === "canceled_by_card" /* CanceledByCard */)
            return 1;
        if (student2.status === "canceled_by_teacher" /* CanceledByTeacher */)
            return 1;
        if (student2.status === "canceled_by_time" /* CanceledByTime */)
            return 1;
        if (student1.status === "expired" /* Expired */)
            return -1;
        if (student2.status === "expired" /* Expired */)
            return 1;
    }
    return sortByName(student1, student2);
};
var sortNeedInterventionStudents = function (student1, student2) {
    return sortByAccuracy(student1, student2);
};
var sortStudents = function (student1, student2, filter) {
    if (filter === "OnTrack" /* OnTrack */)
        return sortOnTrackStudents(student1, student2);
    if (filter === "NotStarted" /* NotStarted */)
        return sortNotStartedStudents(student1, student2);
    if (filter === "NeedIntervention" /* NeedIntervention */)
        return sortNeedInterventionStudents(student1, student2);
    return sortByName(student1, student2);
};
var checkIfStudentNotStarted = function (student) {
    return student.status === "not_started" /* NotStarted */ ||
        ([
            "canceled_by_card" /* CanceledByCard */,
            "canceled_by_teacher" /* CanceledByTeacher */,
            "canceled_by_time" /* CanceledByTime */,
            "expired" /* Expired */,
        ].includes(student.status) &&
            !student.total);
};
export var groupStudentsByTableFilters = function (students) {
    return FILTER_GROUPS_BY_ORDER.reduce(function (acc, current) {
        var _a;
        return __assign(__assign({}, acc), (_a = {}, _a[current] = students
            .filter(function (el) {
            var isNotStarted = checkIfStudentNotStarted(el);
            if (current === "NotStarted" /* NotStarted */) {
                return isNotStarted;
            }
            var hasIntervention = el.struggled ||
                el.cards.some(function (card) { return card.struggledTime || card.struggledAccuracy; });
            if (current === "NeedIntervention" /* NeedIntervention */) {
                return hasIntervention;
            }
            return !hasIntervention && !isNotStarted;
        })
            .sort(function (a, b) { return sortStudents(a, b, current); }), _a));
    }, {});
};
export var addTitleRowsIntoStudents = function (groupedStudents) {
    return FILTER_GROUPS_BY_ORDER.reduce(function (acc, current) {
        if (groupedStudents[current].length === 0)
            return acc;
        var titleRow = {
            name: LabelByStudentsFilter[current] + " (" + groupedStudents[current].length + ")",
        };
        return __spreadArray(__spreadArray(__spreadArray([], acc, true), [titleRow], false), groupedStudents[current], true);
    }, []);
};
export var updateStudentInList = function (_a) {
    var assignments = _a.assignments, updatedStudentId = _a.updatedStudentId, params = _a.params;
    return assignments.map(function (el) {
        if (el.id === updatedStudentId)
            return __assign(__assign({}, el), params);
        return el;
    });
};
export var isStudentCell = function (data) {
    return data.id !== undefined;
};
export var StudentsTableColumnWidth = {
    NAME: 230,
    STATUS: 120,
    ACCURACY: 130,
    TIME: 197,
    ACTIONS: 277,
};
